import { useContext } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import { store } from '../store';
import { SET_IMAGE_DOWNLOADED, SET_IMAGE_DOWNLOADING } from '../types';

const MessageExampleIcon = () => {
  const { imageDownloaded, imageDownloading, dispatch } = useContext(store);

  const close = () => {
    dispatch({ type: SET_IMAGE_DOWNLOADING, payload: false });
    dispatch({ type: SET_IMAGE_DOWNLOADED, payload: false });
  };

  return imageDownloading || imageDownloaded ? (
    <Message
      icon
      floating
      compact
      info={imageDownloading}
      positive={imageDownloaded}
      onDismiss={close}
    >
      <Icon
        name={imageDownloaded ? 'check circle outline' : 'circle notched'}
        loading={imageDownloading}
      />
      <Message.Content>
        <Message.Header>
          {imageDownloaded ? 'Download Complete' : 'Downloading Image'}
        </Message.Header>
        {imageDownloaded
          ? `The download is complete! Look in your device's download folder.`
          : 'This will just take a moment!'}
      </Message.Content>
    </Message>
  ) : null;
};

export default MessageExampleIcon;
